import React from 'react';
import { useTranslation } from 'react-i18next';
import Image from 'next/image';
import Icon from '../../../Icon';
import UserIcon from '../../../../public/static/images/item/user.svg';
import {
  OwnerInfoCompany,
  OwnerInfoContainer,
  OwnerInfoContent,
  OwnerInfoLogo,
  OwnerInfoOwnership
} from './styled';
import { capitalizeFirstLetter } from '../../../../utils/helpers/common';

interface OwnerInfoSectionProps {
  ownerName?: string | null;
  ownership?: string | null;
  logoUrl?: string | null;
  isAgency: boolean;
  isResidence: boolean;
}

export const OwnerInfoSection: React.FC<OwnerInfoSectionProps> = ({
  ownerName,
  ownership,
  logoUrl,
  isAgency,
  isResidence
}) => {
  const { t } = useTranslation();

  const isAgencyOrResidence = isAgency || isResidence;

  return (
    <OwnerInfoContainer data-cy="owner-info" $isResidence={isResidence}>
      <OwnerInfoContent data-cy="owner-info__content">
        <OwnerInfoCompany
          tag={isAgencyOrResidence ? 'title_4_new' : 'body_3'}
          $isResidence={isResidence}
        >
          {ownerName}
        </OwnerInfoCompany>

        <OwnerInfoOwnership tag="body_2">
          {capitalizeFirstLetter(
            ownership || t('pages.current_item.owner_info.residence')
          )}
        </OwnerInfoOwnership>
      </OwnerInfoContent>

      {logoUrl ? (
        <OwnerInfoLogo>
          <Image src={logoUrl} alt="photo" width={55} height={55} />
        </OwnerInfoLogo>
      ) : (
        <Icon indent={false} height={50} width={50} IconComponent={UserIcon} />
      )}
    </OwnerInfoContainer>
  );
};
